import { ACModalV2Placement } from "ac-components/ac-modal/ACModalV2";

export const AssetModalCommonConfig = {
  width: 1024,
  mask: true,
  settingsPrefixKey: "asset-details",
  defaultPlacement: "right" as ACModalV2Placement,
  resize: true,
};
